/* eslint-disable react/jsx-key */
/* eslint-disable max-len */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable no-undef */
import React, { useContext, useState,useEffect,useCallback } from 'react';
import { useRef } from 'react';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { CDN } from '../../constants';
import { DistributorActions } from '../../redux/actions';
import { distributorService } from '../../service/distributor.service';
import CustomToast from '../AlertPopup';
import HeaderContext from '../Context/HeaderContext';
import NotificationDropdown from '../NotificationModal';
import PrefrencesModal from '../PrefrencesModal';
import { AccessPrevilegesFunction, AccessCategoryPrevilegesFunction } from '../../constants/globalPrivilegesFunction';


function Header({GetCartItems,Cart}) {
    const [loggedIn, setloggedIn] = useState(false);
    const [threeDotLoader, setThreeDotsLoader] = useState(false);
    const [profileUrl, setprofileUrl] = useState('/images/Ellipse706.png')
    const [subuserLoggedIn, setSubuserLoggedIn] = useState(false)
    const [reportsDropdown, setReportsDropdown] = useState(false)
    const [notificationDropdown,setNotificationDropdown] = useState(false)
    const [prefrencesModal, setPrefrencesModal] = useState(false)
    const [notificationList, setNotificationList] = useState([])
    const [currentUserPrevilages, setcurrentUserPrevilages] = useState([])
    const [responsive, setresponsive] = useState(false)
    
    // Check if any report page is active
    const isReportPageActive = () => {
        const reportPaths = [
            '/mis-reports/indent-report',
            '/mis-reports/pending-order-statement-report',
            '/mis-reports/invoice-report',
            '/mis-reports/outstanding-report',
            '/mis-reports/outstanding-invoice-details-report',
            '/mis-reports/credit-debit-details'
        ];
        return reportPaths.includes(window.location.pathname);
    };
    const [notificationPrefrences, setNotificationprefrences] = useState({
        whatsapp:false,
        email:false,
        sms:false
    })
    const [notificationError, setNotificationError] = useState(false)
    const profile = JSON.parse(localStorage.getItem('user'))?.profile
    const HomePageNav = [{
        name:'Home',
        url:'/'
    },{
        name:'Our Products',
        url:'/products'
    },
    // {
    //     name:'Resources',
    //     url:'/manage-resource'
    // },
    {
        name:'Offers',
        url:'/offers'
    },
    // {
    //     name:'Bulk Offers',
    //     url:'/bulk-offer'
    // },
    {
        name:'Reports',
        url:'/reports',
        active: '/images/Component1321.svg',
        inactive: '/images/manage_categories_default.svg',
    },
    ];
    const [navBarTabs, setNavBarTabs] = useState(HomePageNav)
    const [notificationCount, setNotificationCount] = useState(0)
    const sidemenu=[{
        id:1,
        menu_name:'profile'
        
    },{
        id:2,
        menu_name:'manage-assistant-users'
    }]
    const { isPopup,
        setisPopup,
        ErrorMessage,
        SuccessMessage,
        colorValue,
        cartCount,
        setraiseTicket,
        SetSuccessMessage,
        setcolorValue,
    } = useContext(HeaderContext);
    const [toggles, settoggles] = useState({
        sidebar:false,
        profileMEnu:false
    })
    const [activeUrl, setactiveUrl] = useState('');
    const privilagesAssigned = AccessPrevilegesFunction('ador_cash_ledger')
    const raiseticketPrivilages = AccessPrevilegesFunction('raise_ticket')
    const creditDebitPrivilages = AccessPrevilegesFunction('credit_debit:list')

    const handleFetchNotifications = async () => {
        const response = await distributorService.NotificationList()
        if(response.error === false) {
            setNotificationList(response.data.data.Items)
            const result = response.data.data.Items.reduce(function (acc, obj) { return acc + (obj.read_status === false ? 1: 0); }, 0);
            setNotificationCount(result)
        }
    }

    const handleToggle = ()=>{
        setraiseTicket(false);
        settoggles((prvstate)=>({
            ...prvstate,
            sidebar:!toggles.sidebar,
            // profileMEnu:!toggles.profileMEnu
        })) 
        setresponsive(false)
    }

    let profileRef = useRef();
    let notificationRef = useRef();

    const location = useLocation();

    useEffect(() => {
        settoggles((prvstate)=>({
            ...prvstate,
            profileMEnu:false,
        }))
        setNotificationDropdown(false)
        setReportsDropdown(false) 
    }, [location]);

    useEffect(() => {
        let handler = (event) => {
            if(profileRef && !profileRef?.current?.contains(event?.target)) {
                settoggles((prvstate)=>({
                    ...prvstate,
                    profileMEnu:false,
                }))
                // setNotificationDropdown(false)
                // setReportsDropdown(false)               
            }   
        }
        document.addEventListener('mousedown', handler)
    
        return () => {
            document.removeEventListener('mousedown', handler)
        }
    },[profileRef])

    useEffect(() => {
        let handler = (event) => {
            if(notificationRef && !notificationRef?.current?.contains(event.target)) {
                // settoggles((prvstate)=>({
                //     ...prvstate,
                //     profileMEnu:false,
                // }))
                setNotificationDropdown(false)
                // setReportsDropdown(false)               
            }   
        }
        document.addEventListener('mousedown', handler)
    
        return () => {
            document.removeEventListener('mousedown', handler)
        }
        
    },[notificationRef])
    
    const handleFetch =useCallback(
        () => {
            GetCartItems()
        },
        [cartCount,SuccessMessage],
    )
    useEffect(() => {
        if (profile) handleFetch();
        if(Object(profile).hasOwnProperty('profile_image_url')){
            setprofileUrl(`${CDN}/${profile.profile_image_url}`)
        }
        const userType = JSON.parse(localStorage.getItem('user'))?.logged_in_user
        if(userType === "subuser"){
            setSubuserLoggedIn(true)
        } else {
            setSubuserLoggedIn(false)           
        }

       
    }, [handleFetch])
    
    useEffect(() => {
        if (JSON.parse(localStorage.getItem('user'))) {
            setloggedIn(true);
        }
        setactiveUrl(window.location.pathname)
    }, [handleToggle]);

    const handleProfileMenu=()=>{
        settoggles((prvstate)=>({
            ...prvstate,
            profileMEnu:!toggles.profileMEnu
        }))
        setNotificationDropdown(false)
    }

    function Message() {
        return (
            <p className="text-[#090406] font-medium pl-[12px] py-3 pr-3 break-words" style={{ fontSize: '15px', color: '#808285', maxWidth: '380px' }}>
                {ErrorMessage || SuccessMessage}
            </p>
        );
    }

    useEffect(() => {
        if (localStorage.getItem('user')) handleFetchNotifications()    
    }, [])

    const add = async () => {
        const currentUserPrevilages = JSON.parse(localStorage.getItem('user'))?.profile?.PRIVILAGES || [];
        let copy = [...navBarTabs]
        if(AccessCategoryPrevilegesFunction('bulk_deal_visibility')){
            copy.push({
                name:'Bulk Offers',
                url:'/bulk-offer'
            })
        }
        if (currentUserPrevilages.includes('resources_visibility')) {
            copy.push({
                name:'Resources',
                url:'/manage-resource'
            })
        }
        setNavBarTabs(copy)
    }
                                                                                                                                                                                   
    useEffect(() => {
        add()
        const currentPreferences = JSON.parse(localStorage.getItem('user'))?.profile?.notification_preferences;
        if(currentPreferences !== undefined && currentPreferences !== null) {
            setNotificationprefrences((prevState) => ({
                ...prevState,
                whatsapp:currentPreferences.whatsapp === undefined ? false :currentPreferences.whatsapp,
                email:currentPreferences.email === undefined ? false :currentPreferences.email,
                sms:currentPreferences.sms === undefined ? false :currentPreferences.sms,        
            }))
        }
    }, [])

    
    const handleSetNotificationPreferences = async () => {
        const payload = {
            notification_preferences : {
                whatsapp:notificationPrefrences.whatsapp,
                email:notificationPrefrences.email,
                sms:notificationPrefrences.sms,
            }
        }
        if(payload.notification_preferences.email || payload.notification_preferences.sms){
            setThreeDotsLoader(true)
            const response = await distributorService.UpdateDistributor(payload)
            if(!response.error) {
                setPrefrencesModal(false)
                setThreeDotsLoader(false)
                SetSuccessMessage(response.data.message)
                setNotificationError(false)
                setTimeout(() => {
                    SetSuccessMessage('')               
                }, 1000);     
            } else {
                setPrefrencesModal(false)
                setThreeDotsLoader(false)
                setNotificationError(false)
                setcolorValue('red')
                SetSuccessMessage(response.data.message)
                setTimeout(() => {
                    SetSuccessMessage('')   
                    setcolorValue()            
                }, 1000); 
            }
        }else{
            setNotificationError(true)    
        }
    }

    const handleLogout=()=>{
        localStorage.clear();
        window.location.reload()
    }

    return (
        <>  
            <div className={`sticky top-0 left-0 ${isPopup?'':'z-50'}`} style={{zIndex: '8'}}>
                <div className="bg-[#FFFFFF] border-b border-[#EBEBEB]" style={{zIndex: '8'}}>
                    <nav className={`md:px-[46px] px-4 py-[18px] flex items-center justify-between sticky top-0 left-0 ${isPopup?'':'z-50'}`}>
                        <ul className="flex items-center justify-between w-full">
                            <li>
                                <ul className="flex items-center">
                                    <li>
                                        <a href="https://www.adorwelding.com/" target="_blank">
                                            <img src="/images/Group8786.png" alt="icon" />
                                        </a>
                                    </li>
                                    {
                                        loggedIn && (ErrorMessage !== '' || SuccessMessage !== '') && (
                                            <CustomToast
                                                open
                                                color={colorValue ? '#ED1C24' : undefined}
                                                message={<Message />}
                                            />
                                        )
                                    }
                                    {loggedIn && (
                                        <li className="lg:pl-14 pl-3">
                                            <div className="flex">
                                                <ul className="xl:flex hidden items-center pl-5 list">
                                                    {navBarTabs.map((item,i)=>(
                                                        <div className='relative'>
                                                            {item.name === 'Reports' ? 
                                                                <div>
                                                                    <button 
                                                                        onClick={() => setReportsDropdown(!reportsDropdown)}
                                                                        className={`text-base cursor-pointer nav-bar flex items-center ${reportsDropdown || isReportPageActive() ? 'product relative font-semibold text-[#090406]':'font-normal text-[#555259]'} ${item.url !=='/'?'pl-[35px]':''}`}
                                                                    >
                                                                        Reports
                                                                        <img 
                                                                            src="/images/chevron-down.svg" 
                                                                            alt="icon" 
                                                                            className={`cursor-pointer w-3 h-3 ml-1.5 ${reportsDropdown || isReportPageActive() ? '' : 'opacity-50'}`}
                                                                            style={{ filter: reportsDropdown || isReportPageActive() ? 'brightness(0) saturate(100%) invert(15%) sepia(95%) saturate(7158%) hue-rotate(350deg) brightness(93%) contrast(92%)' : 'none' }}
                                                                        />                                                               
                                                                    </button>
                                                                    {reportsDropdown && (
                                                                        <ul onClick={() => setReportsDropdown(false)} className="dropdown-menu min-w-max absolute top-[40px] w-[272px] shadow-s11 py-3 px-1 rounded-lg rounded-tl-none bg-[#ffffff]" aria-labelledby="reportDropdown">
                                                                            <li className="mt-2">
                                                                                <Link 
                                                                                    to='/mis-reports/indent-report' 
                                                                                    className={`dropdown-item py-2 px-3 text-sm cursor-pointer rounded ${
                                                                                        window.location.pathname === '/mis-reports/indent-report' 
                                                                                            ? 'text-[#000000] font-bold bg-[#F5F5FA]' 
                                                                                            : 'text-[#000000] font-normal'
                                                                                    }`}
                                                                                    href="Indent-report-listing-page.html">
                                                                                    Indent Report
                                                                                </Link>
                                                                            </li>
                                                                            <li className="mt-2">
                                                                                <Link 
                                                                                    to='/mis-reports/pending-order-statement-report'
                                                                                    className={`dropdown-item py-2 px-3 text-sm cursor-pointer rounded ${
                                                                                        window.location.pathname === '/mis-reports/pending-order-statement-report' 
                                                                                            ? 'text-[#000000] font-bold' 
                                                                                            : 'text-[#000000] font-normal'
                                                                                    }`}
                                                                                    href="pending-order-statement-report-list.html">
                                                                                    Pending Order Statement Report
                                                                                </Link>
                                                                            </li>
                                                                            <li className="mt-2">
                                                                                <Link 
                                                                                    to='/mis-reports/invoice-report' 
                                                                                    className={`dropdown-item py-2 px-3 text-sm cursor-pointer rounded ${
                                                                                        window.location.pathname === '/mis-reports/invoice-report' 
                                                                                            ? 'text-[#000000] font-bold' 
                                                                                            : 'text-[#000000] font-normal'
                                                                                    }`}
                                                                                    href="invoice-report-listing-page.html">
                                                                                    Invoice Report
                                                                                </Link>
                                                                            </li>
                                                                            <li className="mt-2">
                                                                                <Link 
                                                                                    to='/mis-reports/outstanding-report'
                                                                                    className={`dropdown-item py-2 px-3 text-sm cursor-pointer rounded ${
                                                                                        window.location.pathname === '/mis-reports/outstanding-report' 
                                                                                            ? 'text-[#000000] font-bold' 
                                                                                            : 'text-[#000000] font-normal'
                                                                                    }`}
                                                                                    href="outstanding-report-list.html">
                                                                                    Outstanding Report
                                                                                </Link>
                                                                            </li>
                                                                            <li className="mt-2">
                                                                                <Link 
                                                                                    to='/mis-reports/outstanding-invoice-details-report'
                                                                                    className={`dropdown-item py-2 px-3 text-sm cursor-pointer rounded ${
                                                                                        window.location.pathname === '/mis-reports/outstanding-invoice-details-report' 
                                                                                            ? 'text-[#000000] font-semibold' 
                                                                                            : 'text-[#000000] font-normal'
                                                                                    }`}
                                                                                    href="Outstanding-invoice-details-report-list.html">
                                                                                    Outstanding Invoice Details Report                                                
                                                                                </Link>
                                                                            </li>
                                                                            {creditDebitPrivilages && (
                                                                                <li className="mt-2">
                                                                                    <Link 
                                                                                        to='/mis-reports/credit-debit-details'
                                                                                        onClick={() => setReportsDropdown(false)}
                                                                                        className={`dropdown-item py-2 px-3 text-sm cursor-pointer rounded ${
                                                                                            window.location.pathname === '/mis-reports/credit-debit-details' 
                                                                                                ? 'text-[#000000] font-bold' 
                                                                                                : 'text-[#000000] font-normal'
                                                                                        }`}
                                                                                        href="credit-debit-details.html">
                                                                                        Credit/Debit Details                                                
                                                                                    </Link>
                                                                                </li>
                                                                            )}       
                                                                    
                                                                        </ul>) }
                                                                </div> : 
                                                                (<div key={i}  onClick={()=>{handleToggle()}}>
                                                                    <Link to={item.url} key={item.url} onClick={()=>{
                                                                        setisPopup(false);
                                                                        handleToggle()}}>
                                                                        <li
                                                                            onClick={() => setReportsDropdown(false)}
                                                                            className={`text-base cursor-pointer nav-bar ${item.url===window.location.pathname ? 'product relative font-semibold text-[#090406]':'font-normal text-[#555259]'} ${item.url !=='/'?'pl-[35px]':''}`}>
                                                                            {item.name}
                                                                        </li>
                                                                    </Link>
                                                                </div>)
                                                            }
                                                        </div>                                      
                                                    ))}
                                                
                                                </ul>
                                                {/* <div className="relative ml-16 sm:block hidden">
                                                <label htmlFor="search"></label>
                                                <input type="text" name="search" id="search" className="w-[278px] h-9 bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]" placeholder="Search" autoComplete="off" />
                                                <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer" />
                                            </div> */}
            
                                            </div>
                                        </li>
                                    )}
                                </ul>
                            </li>
                            <li>
                                {loggedIn &&
                                <ul className="xl:flex hidden items-center justify-end pl-2">
                                    <li>
                                        <img 
                                            src={`/images/${notificationCount > 0 ? 'Notification-Active.svg' : 'Notification.png'}`}
                                            className="cursor-pointer" 
                                            alt="icon" 
                                            onClick={() => setNotificationDropdown(!notificationDropdown)}
                                        />
                                    </li>
                                    <li className="pl-[22px]" onClick={()=>{handleToggle()}}>
                                        <Link to={'/wishlist'}> <img src={`/images/${window.location.pathname==='/wishlist'?'heart_active.svg':'Iconawesome-heart.png'}`} className="cursor-pointer" alt="icon" /></Link>
                                    </li>
                                    <li className="pl-[22px] relative" onClick={()=>{handleToggle()}}>
                                        <Link to={'/cart'}> 
                                            <img src={`/images/${window.location.pathname==='/cart' || Object.keys(Cart)?.length > 0 && Cart?.items?.length >0 ?'cart-active-empty.svg':'cart.png'}`} className="cursor-pointer" alt="icon" />
                                            {Object.keys(Cart).length > 0 && Cart?.items.length >0 &&(
                                                <div className="absolute top-[-12px] right-[-13px] px-1.5 rounded-md text-xs font-semibold text-[#FFFFFF] bg-[#ED1C24]">
                                                    {Cart?.items?.length}
                                                </div>
                                            )}
                                        </Link>

                                    </li>
                                    <li className="pl-10 relative">
                                        <ul>
                                            <li>
                                                <div className="relative">
                                                    <button type="button" style={{border:'2px solid #eb4631 ',borderRadius:'50%'}}>
                                                        <img  style={{borderRadius:'50%',objectFit:'cover'    }} src={profileUrl} className="cursor-pointer profile-click w-[43px] h-[43px]" alt="icon" onClick={ () => handleProfileMenu()}/>
                                                    </button>
                                                    <div ref={profileRef} className={`absolute top-11 right-0 ${toggles.profileMEnu ? '' : 'hidden'} profile-info w-[272px] `}>
                                                        <div className="rounded-[10px] bg-[#FFFFFF] shadow-s2">
                                                            <div className="pt-[26px] flex pl-[8px] pr-[60px] items-center" onClick={()=>handleProfileMenu()}>
                                                                {activeUrl ==='/profile' && <img src="/images/reddot.svg" alt="icon" className="pb-3.5" />}
                                                                <Link to={'/profile'} className="w-full"><p className="text-lg font-semibold text-[#44445E] pl-[9px] border-b border-[#A5A5A5] w-full pb-3.5">Profile</p></Link>
                                                            </div>
                                                            <div className="pl-[19px] pr-[60px] pt-3">
                                                                <div className='flex items-center'>{activeUrl ==='/orders' && <img src="/images/reddot.svg" alt="icon" className="pb-3.5 mr-3" />}
                                                                    <Link to={'/orders'}><p className="text-lg font-semibold text-[#44445E] w-full pb-2.5" 
                                                                        onClick={()=>{
                                                                            handleProfileMenu()}}>My Orders</p>
                                                                    </Link>
                                                                </div>
                                                                {raiseticketPrivilages && (
                                                                    <p className="text-lg font-semibold text-[#44445E] w-full pb-2.5 cursor-pointer" 
                                                                        onClick={()=>{
                                                                            handleProfileMenu()
                                                                            setraiseTicket(true)}}>Raise a Ticket
                                                                    </p>
                                                                )}
                                                                <div className='flex items-center'>{activeUrl ==='/invoices' && <img src="/images/reddot.svg" alt="icon" className="pb-3.5 mr-3" />}
                                                                    <Link to={'/invoices'}>
                                                                        <p onClick={()=>{
                                                                            handleProfileMenu()}} className="text-lg font-semibold text-[#44445E] w-full pb-2.5">Invoices</p>
                                                                    </Link>
                                                                </div>
                                                                {privilagesAssigned && (
                                                                    <div className='flex items-center'>{activeUrl ==='/list-of-transactions' && <img src="/images/reddot.svg" alt="icon" className="pb-3.5 mr-3" />}

                                                                        <Link to={'/list-of-transactions'} className="w-full">
                                                                            <p onClick={()=>{
                                                                                handleProfileMenu()}} className="text-lg font-semibold text-[#44445E] w-full pb-2.5 border-b border-[#A5A5A5]" >Ador Cash</p>
                                                                        </Link>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="pl-[19px] pr-[60px] pt-3" onClick={()=>{
                                                                handleToggle();
                                                                handleProfileMenu()
                                                            }}>
                                                                {!subuserLoggedIn && AccessPrevilegesFunction('manage_assistant_user') &&
                                                                <div className='flex items-center'>{activeUrl ==='/manage-assistant-users' && <img src="/images/reddot.svg" alt="icon" className="pb-3.5 mr-3" />}
                                                                    <Link to='/manage-assistant-users'><p className="text-lg font-semibold text-[#44445E] w-full pb-2.5">User Management</p></Link>
                                                                </div>
                                                                }
                                                                <p onClick={() => setPrefrencesModal(!prefrencesModal)} className="text-lg font-semibold text-[#44445E] w-full pb-2.5 border-b cursor-pointer border-[#A5A5A5]">Notification Preferences</p>
                                                            </div>
                                                            <div className="pl-[19px] pr-[60px] pt-3 flex items-center">{activeUrl ==='/ador-support' && <img src="/images/reddot.svg" alt="icon" className="pb-3.5 mr-3" />}
                                                                <Link to='/ador-support'><p 
                                                                    onClick={()=>{
                                                                        handleProfileMenu()}} className="text-lg font-semibold text-[#44445E] w-full pb-2.5 border-b border-[#A5A5A5]">Ador Support</p></Link>
                                                            </div>
                                                            <button 
                                                                onClick={()=>handleLogout()} type="button" className="w-[110px] h-[33px] border border-[#090406] rounded mt-3.5 ml-[19px] flex items-center justify-center cursor-pointer">
                                                                <img src="/images/Iconawesome-power-off.png" alt="icon" />
                                                                <span className="text-xs2 font-semibold text-[#090406] pl-1.5">Logout</span>
                                                            </button>
                                                            <p className="pl-[19px] pt-2.5 text-xs2 font-normal text-[#A5A5A5] pb-[18px]">Last Login: {`${profile?.LAST_LOGIN_DATETIME?.split('T')[0]} ${profile?.LAST_LOGIN_DATETIME?.split('T')[1]?.replace('Z','')}`}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>}
                                <ul>
                                    {loggedIn && (
                                        <li className="xl:hidden block">
                                            <button type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample" onClick={()=>handleToggle(true)}>
                                                <img src="/images/sidebar.svg" alt="icon" />
                                            </button>
                                            <div className={`offcanvas offcanvas-start fixed bottom-0 flex flex-col max-w-full bg-[#ffffff] ${toggles.sidebar ? 'visible show' : 'invisible'} bg-clip-padding shadow-sm outline-none transition duration-300 ease-in-out text-gray-700 top-0 left-0 border-none w-96`} tabIndex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
                                                <div className="offcanvas-header flex items-center justify-end p-4">
                                                    <button type="button" className="btn-close box-content w-4 h-4 p-2 -my-5 -mr-2 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline" data-bs-dismiss="offcanvas" aria-label="Close" onClick={()=>handleToggle(false)}></button>
                                                </div>
                                                <div className="offcanvas-body flex-grow p-4 overflow-y-auto" 
                                                // onClick={() =>  settoggles((prevState)=>({
                                                //     ...prevState,
                                                //     sidebar:false
                                                // }))}
                                                >
                                                    <ul className="flex flex-col pl-5 list">
                                                        {navBarTabs.map((item)=>(
                                                            <div>
                                                                {item.name === "Reports" ? 
                                                                    <div>
                                                                        <button 
                                                                            onClick={() => setReportsDropdown(!reportsDropdown)}
                                                                            className={`text-base pt-2 cursor-pointer nav-bar flex items-center ${reportsDropdown || isReportPageActive() ? 'product relative font-semibold text-[#090406]':'font-normal text-[#555259]'}`}
                                                                        >
                                                                            Reports
                                                                            <img 
                                                                                src="/images/chevron-down.svg" 
                                                                                alt="icon" 
                                                                                className={`cursor-pointer w-4 h-4 ml-1.5 ${reportsDropdown || isReportPageActive() ? '' : 'opacity-50'}`}
                                                                                style={{ filter: reportsDropdown || isReportPageActive() ? 'brightness(0) saturate(100%) invert(15%) sepia(95%) saturate(7158%) hue-rotate(350deg) brightness(93%) contrast(92%)' : 'none' }}
                                                                            />                                                               
                                                                        </button>
                                                                        {reportsDropdown && (
                                                                            <ul onClick={() => {setReportsDropdown(false); handleToggle()}} className="" aria-labelledby="reportDropdown">
                                                                                <li className="mt-2">
                                                                                    <Link 
                                                                                        to='/mis-reports/indent-report' 
                                                                                        className={`dropdown-item py-2 px-3 text-sm cursor-pointer rounded ${
                                                                                            window.location.pathname === '/mis-reports/indent-report' 
                                                                                                ? 'text-[#000000] font-bold' 
                                                                                                : 'text-[#000000] font-normal'
                                                                                        }`}
                                                                                        href="Indent-report-listing-page.html">
                                                                                        Indent Report
                                                                                    </Link>
                                                                                </li>
                                                                                <li className="mt-2">
                                                                                    <Link 
                                                                                        to='/mis-reports/pending-order-statement-report'
                                                                                        className={`dropdown-item py-2 px-3 text-sm cursor-pointer rounded ${
                                                                                            window.location.pathname === '/mis-reports/pending-order-statement-report' 
                                                                                                ? 'text-[#000000] font-bold' 
                                                                                                : 'text-[#000000] font-normal'
                                                                                        }`}
                                                                                        href="pending-order-statement-report-list.html">
                                                                                        Pending Order Statement Report
                                                                                    </Link>
                                                                                </li>
                                                                                <li className="mt-2">
                                                                                    <Link 
                                                                                        to='/mis-reports/invoice-report' 
                                                                                        className={`dropdown-item py-2 px-3 text-sm cursor-pointer rounded ${
                                                                                            window.location.pathname === '/mis-reports/invoice-report' 
                                                                                                ? 'text-[#000000] font-bold' 
                                                                                                : 'text-[#000000] font-normal'
                                                                                        }`}
                                                                                        href="invoice-report-listing-page.html">
                                                                                        Invoice Report
                                                                                    </Link>
                                                                                </li>
                                                                                <li className="mt-2">
                                                                                    <Link 
                                                                                        to='/mis-reports/outstanding-report'
                                                                                        className={`dropdown-item py-2 px-3 text-sm cursor-pointer rounded ${
                                                                                            window.location.pathname === '/mis-reports/outstanding-report' 
                                                                                                ? 'text-[#000000] font-bold' 
                                                                                                : 'text-[#000000] font-normal'
                                                                                        }`}
                                                                                        href="outstanding-report-list.html">
                                                                                        Outstanding Report
                                                                                    </Link>
                                                                                </li>
                                                                                <li className="mt-2">
                                                                                    <Link 
                                                                                        to='/mis-reports/outstanding-invoice-details-report'
                                                                                        className={`dropdown-item py-2 px-3 text-sm cursor-pointer rounded ${
                                                                                            window.location.pathname === '/mis-reports/outstanding-invoice-details-report' 
                                                                                                ? 'text-[#000000] font-bold' 
                                                                                                : 'text-[#000000] font-normal'
                                                                                        }`}
                                                                                        href="Outstanding-invoice-details-report-list.html">
                                                                                        Outstanding Invoice Details Report                                                
                                                                                    </Link>
                                                                                </li>
                                                                                {creditDebitPrivilages && (
                                                                                    <li className="mt-2">
                                                                                        <Link 
                                                                                            to='/mis-reports/credit-debit-details'
                                                                                            onClick={() => {setReportsDropdown(false); handleToggle()}}
                                                                                            className={`dropdown-item py-2 px-3 text-sm cursor-pointer rounded ${
                                                                                                window.location.pathname === '/mis-reports/credit-debit-details' 
                                                                                                    ? 'text-[#000000] font-bold' 
                                                                                                    : 'text-[#000000] font-normal'
                                                                                            }`}
                                                                                            href="credit-debit-details.html">
                                                                                            Credit/Debit Details                                                
                                                                                        </Link>
                                                                                    </li>
                                                                                )}       
                                                                  
                                                                            </ul>) }
                                                                    </div> :
                                                                    <div onClick={()=>handleToggle()}>
                                                                        <Link to={item.url} key={item.url}><li className={`text-base font-normal text-[#555259] cursor-pointer nav-bar pt-2`}>
                                                                            {item.name}
                                                                        </li>
                                                                        </Link>
                                                                    </div>
                                                                }
                                                            </div>
                                                        ))} 
                                                    </ul>
                                                    <ul className="flex flex-col pl-5">
                                                        <li className="flex items-center"                                        
                                                            onClick={() => setNotificationDropdown(!notificationDropdown)}
                                                        >
                                                            <p className="text-base font-normal text-[#555259] pt-2">Notification</p>
                                                        </li>
                                                        <li className="flex items-center" onClick={()=>{handleToggle()}}>
                                                            <Link to={'/wishlist'}><p className="text-base font-normal text-[#555259] pt-2">Wishlist</p></Link>
                                                        </li>
                                                        <li className="flex items-center" onClick={()=>handleToggle()}>
                                                            <Link to={'/cart'}>  <p className="text-base font-normal text-[#555259] pt-2">Cart</p></Link>
                                                        </li>
                                                        <li className="flex">
                                                            <ul>
                                                                <li>
                                                                    <div className="relative">
                                                                        <button type="button" className="flex pt-2 items-center profile-click">
                                                                            <Link to={'/profile'}><p className="text-base font-normal text-[#555259]" onClick={handleProfileMenu}>Profile</p></Link>
                                                                            <img onClick={()=>setresponsive(!responsive)} src="/images/chevron-down.svg" alt="icon" className="cursor-pointer w-5 h-5 pl-2.5" />
                                                                        </button>
                                                                        <div className={`absolute xl:top-11 top-[52px] xl:right-0 left-0 ${responsive?'show':'hidden'} profile-info w-[272px] z-20 transition-all`}>
                                                                            <div className="rounded-[10px] bg-[#FFFFFF]">
                                                                                <div className="pl-[19px] pr-[60px] pt-3" >
                                                                                    <Link to='/orders'> <p onClick={()=>handleToggle()} className="text-base font-normal text-[#555259] w-full pb-2.5">My Orders</p>
                                                                                    </Link>
                                                                                    <p className="text-base font-normal text-[#555259] w-full pb-2.5 cursor-pointer" onClick={()=>{
                                                                                        handleProfileMenu()
                                                                                        handleToggle()
                                                                                        setraiseTicket(true)}}>Raise a Ticket</p>
                                                                                    <p className="text-base font-normal text-[#555259] w-full pb-2.5 border-b border-[#A5A5A5]">Invoices</p>
                                                                                </div>
                                                                                <div className="pl-[19px] pr-[60px] pt-3" onClick={()=>handleToggle()}>
                                                                                    <Link to='/manage-assistant-users'>
                                                                                        <p className="text-base font-normal text-[#555259] w-full pb-2.5">User Management</p>
                                                                                    </Link>
                                                                                    {/* <Link to='/manage-assistant-users'>
                                                                                    <p className="text-base font-normal text-[#555259] w-full pb-2.5">User Management</p>
                                                                                </Link> */}
                                                                                    <p onClick={() => setPrefrencesModal(true)} className="text-base cursor-pointer font-normal text-[#555259] w-full pb-2.5 border-b border-[#A5A5A5]">Notification Preferences</p>
                                                                                </div>
                                                                                <div className="pl-[19px] pr-[60px] pt-3" onClick={()=>handleToggle()}>
                                                                                    <Link to='/ador-support' className="text-base font-normal text-[#555259] w-full pb-2.5 border-b border-[#A5A5A5]">Ador Support</Link>
                                                                                </div>
                                                                                <button onClick={()=>handleLogout()} type="button" className="w-[110px] h-[33px] border border-[#090406] rounded mt-3.5 ml-[19px] flex items-center justify-center cursor-pointer">
                                                                                    <img src="/images/Iconawesome-power-off.png" alt="icon" />
                                                                                    <span className="text-xs2 md:font-semibold font-normal text-[#090406] pl-1.5">Logout</span>
                                                                                </button>
                                                                                <p className="pl-[19px] pt-2.5 text-xs2 font-normal text-[#A5A5A5] pb-[18px]">Last Login: {`${profile?.LAST_LOGIN_DATETIME?.split('T')[0]} ${profile?.LAST_LOGIN_DATETIME?.split('T')[1]?.replace('Z','')}`}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </li>
                                    )}
                                </ul>
                            </li>
                        </ul>
                    </nav>
                    <div className="collapse bg-white z-50" id="collapseExample">
                        <div className="w-full inline-block p-6 pt-0 rounded-lg shadow-lg bg-white">
                            <input type="text" name="search" id="search" className="w-full h-9 bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]" placeholder="Search" autoComplete="off" />
                        </div>
                    </div>
                </div>
                {notificationDropdown && <NotificationDropdown
                    notificationDropdown={notificationDropdown}
                    setNotificationDropdown={setNotificationDropdown} 
                    notificationList={notificationList}
                    setNotificationList={setNotificationList}
                    notificationCount={notificationCount}
                    setNotificationCount={setNotificationCount}
                    handleFetchNotifications={handleFetchNotifications}
                    notificationRef={notificationRef}
                />}
            </div>
            {prefrencesModal && <PrefrencesModal
                prefrencesModal={prefrencesModal}
                setPrefrencesModal={setPrefrencesModal}
                notificationPrefrences={notificationPrefrences}
                setNotificationprefrences={setNotificationprefrences}
                handleSetNotificationPreferences={handleSetNotificationPreferences}
                notificationError={notificationError}
                setNotificationError={setNotificationError}
                threeDotLoader={threeDotLoader}
                setThreeDotsLoader={setThreeDotsLoader}
            />}
        </>
    );
}
const mapStateToProps = (state) => {
    const { Cart } = state;
    return { Cart };
}

const mapDispatchToProps = {
    GetCartItems:DistributorActions.GetCartItems
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
